import { Chip, Tooltip } from "@mui/material";
import { memo } from "react";

import { useQueryParams } from "../../../../../hooks/useQueryParams";
import { MultiSelectDB, SingleSelectDB } from "../../utils/store";

const CaseListChips = ({ activeFilters = [] }) => {
  const { updateFilter, bulkUpdateFilters } = useQueryParams();

  const handleChipDelete = async (filterConfig) => {
    if (["DateRange", "RangeSlider"].includes(filterConfig.filterType)) {
      // For range filters, clear both __gte and __lte
      bulkUpdateFilters([
        [filterConfig.fieldName + "__gte", null],
        [filterConfig.fieldName + "__lte", null],
      ]);
    } else if (filterConfig.filterType === "MultiSelectSearch") {
      // For multi-select, clear both possible parameter names
      bulkUpdateFilters([
        [filterConfig.fieldName, null],
        [filterConfig.fieldName + "__in", null],
      ]);
      await MultiSelectDB.delete(filterConfig.fieldName);
    } else {
      if (filterConfig.filterType === "SingleSelect") {
        await SingleSelectDB.delete(filterConfig.fieldName);
      }
      // For single value filters
      updateFilter(filterConfig.fieldName, null);
    }
  };

  return (
    <div className="flex w-full gap-2 mb-4 overflow-x-auto flex-nowrap">
      {activeFilters.length > 0
        ? activeFilters.map((filterConfig, index) => {
            const chipLabel = `${filterConfig.title}: ${filterConfig.activeChip.label}`;

            return (
              <Tooltip
                title={chipLabel}
                arrow
                key={`${filterConfig.fieldName}-${index}`}
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, -8],
                        },
                      },
                    ],
                  },
                }}
              >
                <Chip
                  className="px-2 text-center rounded-lg shadow-inner w-fit text-wrap"
                  color="primary"
                  onDelete={() => handleChipDelete(filterConfig)}
                  label={chipLabel}
                />
              </Tooltip>
            );
          })
        : null}
    </div>
  );
};

export default memo(CaseListChips);
